<template>
  <div>
    <div v-for="(entry, itemObjKey) in menuEntries" :key="itemObjKey">
      <div 
        :class="{ 'option-menu-entry-active': itemObjKey === activeEntry }" 
        class="option-menu-entry"
        @click="sendChangeMessageToParent(itemObjKey)" 
        v-html="entry">
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const props = defineProps({
  menuEntries: {
    type: Array,
    required: true
  },
  initValue: {
    type: Number,
    default: 2
  }
});

const emits = defineEmits(['onMenuChange']); 

// Initialize activeEntry with the provided initValue or default to 0
const activeEntry = ref(props.initValue);

// Update activeEntry to use the initValue prop after the component is mounted
onMounted(() => {
  activeEntry.value = props.initValue;
});

const sendChangeMessageToParent = (newValue) => {
  activeEntry.value = newValue;
  
  emits('onMenuChange', { active_entry: activeEntry.value, active_string: props.menuEntries[activeEntry.value] });
}
</script>



<style lang="scss" scoped>
@import '~/assets/constants.scss';

.option-menu-entry {
  background: rgba($fa-orange, 0.7);
  background: linear-gradient(to bottom, rgba($fa-orange, 0.7), rgba($fa-dark-orange, 0.7));
  margin-bottom: 0.75rem;
  font-weight: bold;
  font-size: 1.25rem;
  cursor: pointer;
  border-top-right-radius: 3rem;
  display: flex;
  justify-content: center;
  width: min-content;
  padding-left: 1rem;
  padding-right: 2rem;
  margin-right: 2rem;
}


.option-menu-entry:hover,
.option-menu-entry-active {
  background: $fa-orange;
  background: linear-gradient(to bottom, $fa-orange, $fa-dark-orange);
  margin-right: 0rem;
}

.light-mode .option-menu-entry {
  color: $light-white;
}
</style>
